export enum HardwareSource {
    Tracker,
    Transcan,
    SecureSeal,
    Ibox,
    Carrier
}
